var map = {
  "./cs.json": [
    "UtU",
    [
      "ym2"
    ]
  ],
  "./en.json": [
    "JWY",
    [
      "v1"
    ]
  ],
  "./pl.json": [
    "yDi",
    [
      "cs"
    ]
  ],
  "./ru.json": [
    "jW",
    [
      "td"
    ]
  ],
  "./tr.json": [
    "Xl",
    [
      "pr"
    ]
  ],
  "./ja.json": [
    "Rvc",
    [
      "bp6"
    ]
  ],
  "./zh.json": [
    "aPZ",
    [
      "4m"
    ]
  ],
  "./pt-br.json": [
    "Bg",
    [
      "z"
    ]
  ],
  "./de.json": [
    "yj",
    [
      "ssq"
    ]
  ],
  "./es.json": [
    "PJ",
    [
      "5s"
    ]
  ],
  "./fr.json": [
    "qz",
    [
      "ol"
    ]
  ],
  "./it.json": [
    "jFQ",
    [
      "xt"
    ]
  ],
  "./ko.json": [
    "rx",
    [
      "hpt"
    ]
  ],
  "./pt.json": [
    "iV6",
    [
      "gx"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "Rr";
module.exports = __rspack_async_context;
